/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Referral_TitleInputs */

const tr_landing_referral_title = /** @type {(inputs: Landing_Referral_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arkadaşınızı getirin,`)
};

const en_landing_referral_title = /** @type {(inputs: Landing_Referral_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bring a friend,`)
};

const de_landing_referral_title = /** @type {(inputs: Landing_Referral_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laden Sie Freunde ein,`)
};

const ru_landing_referral_title = /** @type {(inputs: Landing_Referral_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Приведите друга,`)
};

/**
* | output |
* | --- |
* | "Bring a friend," |
*
* @param {Landing_Referral_TitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_referral_title = /** @type {((inputs?: Landing_Referral_TitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Referral_TitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_referral_title(inputs)
	if (locale === "de") return de_landing_referral_title(inputs)
	if (locale === "ru") return ru_landing_referral_title(inputs)
	return tr_landing_referral_title(inputs)
});